import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { MessageSquare, FileText, Code2, Rocket } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Tell us what you need',
  description: 'Short guided project brief — no technical knowledge required.',
  icon: MessageSquare
}, {
  number: '02',
  title: 'We define milestones',
  description: 'Clear scope, timelines, and acceptance criteria before we start.',
  icon: FileText
}, {
  number: '03',
  title: 'We build & show proof',
  description: 'You review real progress before paying for the next stage.',
  icon: Code2
}, {
  number: '04',
  title: 'Launch with confidence',
  description: 'Final handover, warranty period, and ongoing support.',
  icon: Rocket
}];
export function HowItWorks() {
  return <section className="w-full bg-white py-24 md:py-32 border-t border-neutral-100" data-id="element-33">
      <div className="max-w-7xl mx-auto px-6" data-id="element-34">
        <FadeIn className="mb-20 md:mb-32" data-id="element-35">
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-6" data-id="element-36">
            How it works
          </h2>
          <p className="text-xl text-neutral-500 max-w-xl" data-id="element-37">
            A transparent process designed to reduce risk and ensure quality at
            every step.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-38">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} className="group" data-id="element-39">
              <div className="flex flex-col h-full justify-between" data-id="element-40">
                <div data-id="element-41">
                  <div className="flex items-center justify-between mb-8" data-id="element-42">
                    <span className="text-6xl font-light text-neutral-200 group-hover:text-neutral-300 transition-colors duration-500" data-id="element-43">
                      {step.number}
                    </span>
                    <step.icon className="w-6 h-6 text-neutral-400" data-id="element-44" />
                  </div>
                  <h3 className="text-xl font-medium text-neutral-900 mb-4" data-id="element-45">
                    {step.title}
                  </h3>
                  <p className="text-neutral-500 leading-relaxed" data-id="element-46">
                    {step.description}
                  </p>
                </div>
                <div className="w-full h-px bg-neutral-100 mt-8 group-hover:bg-neutral-200 transition-colors duration-500" data-id="element-47" />
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}